import { Injectable, HostListener } from '@angular/core';
// import { Observable } from 'rxjs-compat/Observable';
import { Observer ,  Subscription ,  fromEvent, merge, of, Observable } from 'rxjs';
import { PushNotificationPermissions } from '../../enum/push-notifications/push-notifications-permitions.enum';
import { PushNotification } from '../../models/push-notification/push-notification.model';
import { PushNotificationEvent } from '../../models/push-notification/push-notification-events';
import { PushNotificationEventName } from '../../enum/push-notifications/push-notification-events.enum';
import { OnDestroy } from '@angular/core';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { pluck } from 'rxjs/operators';
// TODO: Add Angular decorator.
// TODO: Add Angular decorator.
// TODO: Add Angular decorator.
// TODO: Add Angular decorator.
// TODO: Add Angular decorator.
// TODO: Add Angular decorator.
// TODO: Add Angular decorator.
// TODO: Add Angular decorator.
@AutoUnsubscribe()
@Injectable()
export class PushNotificationService implements OnDestroy {
    /**
     * Verifica se o usuário possui permissão ou não.
     *
     */
    private get permission(): PushNotificationPermissions {
        if((<any>Notification).permission == "granted") { return PushNotificationPermissions.Granted }
        else if ((<any>Notification).permission == "denied") { return PushNotificationPermissions.Denied }
        else { return PushNotificationPermissions.Default };
    }
 
    // Verifica se existe suporte a notificação. 
    public haveSupport = "Notification" in window;
    
    private notifications: Array<PushNotification> = [];
    private windowSubscription: Subscription;
    public tabIsActive: boolean = true;
    constructor() {
        const windowFocus = fromEvent(window, 'focus');
        const windowBlur = fromEvent(window, 'blur');
        this.windowSubscription = merge(windowFocus, windowBlur)
            .pipe(
                pluck('type')
            )
            .subscribe((event) => {
                this.tabIsActive = event == 'focus';
            });
    }
    /** 
     * Requere a permissão, se necessário. 
     * */
    public getPermission() {
        if(!this.haveSupport) return;
        if(this.permission == PushNotificationPermissions.Default || this.permission == PushNotificationPermissions.Denied) {
            Notification.requestPermission();
        }
    }
    /**
     * Cria uma nova notificação
     * @param title Titulo da notificação.
     * @param body Corpo da notificação.
     * @param time Tempo para fechar caso queira manter a notificação por um tempo específico.
     * @param notificationOptions Opções das notificações se necessário.
     */
    public newNotification(
        title: string,
        body: string = '',
        time?: number,
        notificationOptions?: NotificationOptions
    ): Observable<PushNotificationEvent> {
        if(this.tabIsActive) return of( new PushNotificationEvent(PushNotificationEventName.NotShow, null) );
        const options: any = notificationOptions || {
            body: body,
            icon: '/android-icon-192x192.png',
            lang: 'pt-br',
            requireInteraction : time ? true : false
        };
        
        const notification = new Notification(title, options);
        const serviceNotification = new PushNotification(notification);
        this.notifications.push(serviceNotification);
        if(time) {
            setTimeout(() => {
                notification.close();
            }, time)
        }
        return this.trackNotificationEvents(serviceNotification);
    }
    /**
     * Recupera uma notificação.
     * @param id ID de um push notification.
     */
    public getNotification(id: string): PushNotification {
        return this.notifications.find(notification => notification.id == id);
    }
    /**
     * Recupera todas notificação.
     */
    public getAllNotification(): Array<PushNotification> {
        return this.notifications;
    }
    /**
     * Retira uma notificação da lista.
     * @param id ID de um push notification.
     */
    public removeNotification(id: string): void {
        const index = this.notifications.findIndex(notification => notification.id == id);
        this.notifications.splice(index, 1);
    }
    /**
     * Cria um observable com os eventos da notificação.
     * @param serviceNotification Notificação criada pelo serviço.
     */
    private trackNotificationEvents(serviceNotification: PushNotification): Observable<PushNotificationEvent> {
        const notification = serviceNotification.notification;
        return Observable.create((observer: Observer<PushNotificationEvent>) => {
            notification.onshow = () => { 
                observer.next( new PushNotificationEvent(PushNotificationEventName.Show, serviceNotification) );
            }
            notification.onclick = () => {
                notification.close();
                observer.next( new PushNotificationEvent(PushNotificationEventName.Click, serviceNotification) );
            }
            notification.onerror = (error) => {
                this.removeNotification(serviceNotification.id);
                observer.error( new PushNotificationEvent(PushNotificationEventName.Error, serviceNotification, error) );
            }
            notification.onclose = () => { 
                this.removeNotification(serviceNotification.id);
                observer.next( new PushNotificationEvent(PushNotificationEventName.Close, serviceNotification) );
                observer.complete();
            }
        });
    }
    ngOnDestroy(){}
}